/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagementCreateMemberRequest = {
    lastName: string;
    firstName: string;
    lastKana?: string | null;
    firstKana?: string | null;
    type: MemberManagementCreateMemberRequest.type;
    companyName?: string | null;
    nickname?: string;
    zip?: string | null;
    address1?: string | null;
    address2?: string | null;
    address3?: string | null;
    tel?: string | null;
    telDaytime?: string | null;
    email?: string;
    password?: string;
    language: MemberManagementCreateMemberRequest.language;
    isNewsletter: boolean;
    isNotice: boolean;
    status: MemberManagementCreateMemberRequest.status;
    eventNumber?: number;
};

export namespace MemberManagementCreateMemberRequest {

    export enum type {
        CONSUMER = 'consumer',
        BUSINESS = 'business',
        MANIA = 'mania',
        EVENT = 'event',
    }

    export enum language {
        JP = 'jp',
        EN = 'en',
        CN = 'cn',
    }

    export enum status {
        AVAILABLE = 'available',
        SUSPENSION = 'suspension',
    }


}

